import { Expose, Transform } from 'class-transformer';

import { BasicUser } from './basic-user-model';

export class TeacherModel extends BasicUser {
  @Expose() brief: string;
  @Expose() briefEn: string;
  @Expose() certificate: string;
  @Expose()
  @Transform(({ value }) => (value && value !== '-' ? value.split(',&,') : []))
  ejaza: string[];
  @Expose() technicalExperience: string;
  @Expose() yearsOfExperience: string;
  @Expose()
  @Transform(({ value }) => (value ? value.split(',&,').join(',') : null))
  languages: string;
}
